import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import { Modal, message } from 'src/Library/AntdLibComponents';
import { BookingDetails } from '../Modals/Booking.types';
import { fetchSplitBookingDetails } from 'src/api/booking';
import SplitBookingDetails from './SplitBookingDetails';

const styles = (theme) => ({
  modal: {
    minWidth: '824px',
  },
});

interface IProps extends
  StylesProps<ReturnType<typeof styles>> {
  isVisible: boolean;
  handleModalClose: () => void;
  bookingData: BookingDetails;
}

interface StateProps {
  splitBookingData: any;
  isLoading: boolean;
}

const SplitBookingDetailsModal = (props: IProps): React.ReactElement => {

  const {
    isVisible,
    classes,
    handleModalClose,
    bookingData,
  } = props;

  const [state, setState] = useGenericState<StateProps>({
    splitBookingData: [],
    isLoading: false,
  });

  const {
    splitBookingData,
    isLoading,
  } = state;

  React.useEffect(() => {
    fetchSplitBookings();
  }, []);

  const fetchSplitBookings = async () => {
    setState({ isLoading: true });
    const response = await fetchSplitBookingDetails(bookingData.id);
    if (response.isSuccess) {
      setState({
        splitBookingData: response.data,
        isLoading: false,
      });
    } else {
      message.error(response.errorMessage);
      setState({
        isLoading: false,
      });
    }
  }

  return (
    <Modal
      visible={isVisible}
      className={classes.modal}
      title={`Booking # ${bookingData.bookingNumber}`}
      onCancel={handleModalClose}
      footer={null}
    >
      <SplitBookingDetails
        isLoading={isLoading}
        splitBookingData={splitBookingData}
      />
    </Modal>
  );
};

export default React.memo(withStyles(styles)(SplitBookingDetailsModal));
